/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：677
 */

module.exports = {
  hide: "style_hide__7pUUu",
  "coco-widget-wrapper": "style_coco-widget-wrapper__2h0-X",
  "coco-child-widget": "style_coco-child-widget__1JzF2",
  "coco-child-widget-selected": "style_coco-child-widget-selected__2AQx0",
  "coco-child-widget-full": "style_coco-child-widget-full__DB-HI",
  screenView: "style_screenView__1wSrw"
}
